import React, { useEffect, useState } from 'react';

const TourSpotlight = ({ selector, title, children, step, total = 4 }) => {
  const [target, setTarget] = useState(null);

  useEffect(() => {
    if (!selector) return undefined;
    let frame;
    const measure = () => {
      const element = document.querySelector(selector);
      if (!element || !element.getClientRects().length) {
        setTarget(null);
        return;
      }
      const rect = element.getBoundingClientRect();
      setTarget({ x: rect.left, y: rect.top, width: rect.width, height: rect.height, viewportWidth: window.innerWidth, viewportHeight: window.innerHeight });
    };
    frame = window.requestAnimationFrame(measure);
    window.addEventListener('resize', measure);
    window.addEventListener('scroll', measure, true);
    return () => {
      window.cancelAnimationFrame(frame);
      window.removeEventListener('resize', measure);
      window.removeEventListener('scroll', measure, true);
    };
  }, [selector]);

  if (!target) return null;

  const tooltipWidth = Math.min(310, target.viewportWidth - 24);
  const left = Math.max(12, Math.min(target.x + target.width / 2 - tooltipWidth / 2, target.viewportWidth - tooltipWidth - 12));
  const top = Math.min(target.y + target.height + 22, target.viewportHeight - 120);

  return (
    <>
      <svg aria-hidden="true" focusable="false" style={{ position: 'fixed', inset: 0, width: '100vw', height: '100vh', zIndex: 13000, pointerEvents: 'none' }} viewBox={`0 0 ${target.viewportWidth} ${target.viewportHeight}`} preserveAspectRatio="none">
        <defs><mask id="nuvia-tour-spotlight"><rect width={target.viewportWidth} height={target.viewportHeight} fill="white" /><rect x={Math.max(0, target.x - 9)} y={Math.max(0, target.y - 9)} width={target.width + 18} height={target.height + 18} rx="14" fill="black" /></mask></defs>
        <rect width={target.viewportWidth} height={target.viewportHeight} fill="rgba(15,23,42,.68)" mask="url(#nuvia-tour-spotlight)" />
        <rect x={target.x - 6} y={target.y - 6} width={target.width + 12} height={target.height + 12} rx="12" fill="none" stroke="#ffffff" strokeWidth="3" />
        <rect x={target.x - 10} y={target.y - 10} width={target.width + 20} height={target.height + 20} rx="15" fill="none" stroke="#2dd4bf" strokeWidth="2" />
      </svg>
      <div role="status" style={{ position: 'fixed', top, left, zIndex: 13002, width: tooltipWidth, padding: '15px 17px', borderRadius: 13, background: '#fff', border: '1px solid #b9dfd2', boxShadow: '0 14px 38px rgba(15,23,42,.24)', color: '#174e43', fontSize: 13, lineHeight: 1.5 }}>
        <strong style={{ display: 'block', marginBottom: 4 }}>Paso {step} de {total} · {title}</strong>
        {children}
      </div>
    </>
  );
};

export default TourSpotlight;
